import { SessionStatusEnum } from '@vette/data-access';
import { message } from '@vette/frontend-utils';
import { useEffect } from 'react';
import { usePreviousDistinct } from 'react-use';

export const useStatusMessage = (
  onFinish: () => void,
  status?: SessionStatusEnum,
  loading?: boolean,
  isPredemo?: boolean
) => {
  const previousStatus = usePreviousDistinct(status);
  useEffect(() => {
    if (!status && !loading && previousStatus) {
      switch (previousStatus) {
        case SessionStatusEnum.SESSION_FINISHED_SUCCESSFULLY:
          message.destroy();
          message.success(
            isPredemo
              ? 'Thank you for your time, a call is complete'
              : 'Thank you for interviewing, your interview is complete!'
          );
          onFinish();
          break;
        case SessionStatusEnum.WAITING_FOR_VETTER_TO_CONFIRM_APPLICANT_PICKED_UP_TIMED_OUT:
        case SessionStatusEnum.VETTER_CLAIMS_APPLICANT_DID_NOT_PICKUP_CALL:
        case SessionStatusEnum.APPLICANT_DID_NOT_PICKUP_CALL:
          message.destroy();
          message.error(
            `Sorry, we couldn't reach you. You can initiate a new ${
              isPredemo ? 'call' : 'interview'
            } when you are ready.`
          );
          onFinish();
          break;

        case SessionStatusEnum.SESSION_FINISHED_WITH_AN_ISSUE:
          message.destroy();
          message.error(
            `Sorry we've noticed your ${
              isPredemo ? 'call' : 'interview'
            } was interrupted, please try again later.`
          );
          onFinish();
          break;

        case SessionStatusEnum.APPLICANT_WAS_NOT_REACHABLE:
          message.destroy();
          message.error(
            'Sorry we were not able to reach you by the phone number you provided. Please check the number and try again.',
            0
          );
          onFinish();
          break;

        case SessionStatusEnum.APPLICANT_HUNG_UP:
          message.destroy();
          message.error(
            `Your ${
              isPredemo ? 'call' : 'interview'
            } ended early. You can start a new one when you're ready.`
          );
          onFinish();
          break;

        case SessionStatusEnum.AI_VETTER_FAILED:
          message.destroy();
          message.error(
            `Something went wrong on our end and we couldn't complete your ${
              isPredemo ? 'call' : 'interview'
            }. Please try again, or contact support if this keeps happening.`,
            0
          );
          onFinish();
          break;

        case SessionStatusEnum.APPLICANT_DID_NOT_PASS_KNOCKOUT:
          message.destroy();
          message.success(
            `Thanks for your time — your ${
              isPredemo ? 'call' : 'interview'
            } is complete.`
          );
          onFinish();
          break;
      }
    } else if (!status && !loading) {
      onFinish();
    }
  }, [status, previousStatus, loading, onFinish, isPredemo]);
};
